import React from 'react';
import imgCorpo from './img/icone-carro-corpo.svg';
import imgLupa1 from './img/icone-carro-lupa-1.svg';
import imgRetangulo from './img/icone-carro-retangulo.svg';
import imgLupa2 from './img/icone-carro-lupa-2.svg';

// No Figma o ícone do carro é montado em camadas (carro, lupa e retângulo) sobre o círculo tracejado.
const IconeCarro = () => (
  <span className="icone">
    <svg className="icone-circulo" width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="36" height="36" rx="18" stroke="#FA9401" strokeDasharray="8 8" />
    </svg>
    <span className="icone-carro">
      <img className="corpo" src={imgCorpo} alt="" />
      <img className="lupa" src={imgLupa1} alt="" />
      <img className="retangulo" src={imgRetangulo} alt="" />
      <img className="lupa" src={imgLupa2} alt="" />
    </span>
  </span>
);

export default IconeCarro;
